import { Link } from 'react-router-dom';
import LegalPageLayout, { LegalSection, LegalList } from './LegalPageLayout';

export default function PrivacyPolicyPage() {
  return (
    <LegalPageLayout title="Gizlilik Politikası" updated="Mayıs 2025">
      <div className="legal-intro">
        <p>
          Bu Gizlilik Politikası, NoteSwapp mobil uygulaması ve web sitesini kullanan kişilerin kişisel verilerinin
          nasıl toplandığını, işlendiğini, saklandığını ve korunduğunu açıklamaktadır.
        </p>
        <p>
          NoteSwapp; TÜBİTAK 2209-B projesi kapsamında Begüm Sezer ve Zeynep Reyyan Kaleli tarafından geliştirilen,
          öğrencilerin ders notlarını paylaşmasını, aramasını ve not değişimi yapmasını amaçlayan akademik bir not
          paylaşım platformudur.
        </p>
        <p>
          Platformu kullanarak bu Gizlilik Politikası&apos;nı okuduğunuzu ve kişisel verilerinizin burada açıklanan
          şekilde işleneceğini anladığınızı kabul etmiş sayılırsınız. Kişisel veri işleme faaliyetlerimiz hakkında daha
          kapsamlı bilgiye ulaşmak için{' '}
          <Link to="/kvkk">KVKK Aydınlatma Metni</Link>&apos;ni inceleyebilirsiniz.
        </p>
      </div>

      <LegalSection title="1. Veri Sorumlusu">
        <p><strong>Veri sorumluları:</strong> Begüm Sezer ve Zeynep Reyyan Kaleli</p>
        <p><strong>Proje:</strong> NoteSwapp</p>
        <p><strong>Proje türü:</strong> TÜBİTAK 2209-B Öğrenci Projesi</p>
        <p><strong>İletişim e-postası:</strong> <a href="mailto:noteswapp@gmail.com">noteswapp@gmail.com</a></p>
        <p>Kişisel verilerinizle ilgili tüm taleplerinizi noteswapp@gmail.com adresi üzerinden bize iletebilirsiniz.</p>
      </LegalSection>

      <LegalSection title="2. Toplanan Kişisel Veriler">
        <p>Platform üzerinden gerçekleştirdiğiniz işlemlere bağlı olarak aşağıdaki kategorilerde kişisel veriler işlenebilir:</p>
        <LegalList items={[
          'Kimlik ve profil bilgileri: Ad, soyad, kullanıcı adı, profil fotoğrafı, üniversite, fakülte, bölüm, sınıf, dönem.',
          'İletişim bilgileri: E-posta adresi, bildirim tercihleri.',
          'Hesap bilgileri: Kullanıcı ID, hesap oluşturma tarihi, giriş yöntemi, oturum bilgileri.',
          'Akademik içerik bilgileri: Yüklenen notlar, dosya adları, ders adı, dönem, açıklama, etiketler, onay durumu.',
          'Kullanım bilgileri: Arama, görüntüleme, indirme, favorileme, takas ve uygulama içi işlem kayıtları.',
          'Teknik veriler: IP adresi, cihaz bilgisi, işletim sistemi, uygulama sürümü, hata ve log kayıtları.',
          'Destek kayıtları: Destek talepleri, geri bildirimler, şikayetler, e-posta yazışmaları.',
          'Yapay zeka analiz sonuçları: Notların kalite, okunabilirlik, kategori uyumu ve uygunluk değerlendirme sonuçları.',
        ]} />
        <p>
          NoteSwapp, kullanıcılardan özel nitelikli kişisel veri (kimlik numarası, sağlık bilgisi, siyasi görüş vb.)
          talep etmez. Kullanıcıların bu tür verileri içeren dosyaları platforma yüklememesi gerekmektedir. Aksine
          davranışlardan ve yüklenen dokümanların içeriğinden doğabilecek hukuki ve cezai sorumluluk tamamen dokümanı
          yükleyen kullanıcıya aittir.
        </p>
      </LegalSection>

      <LegalSection title="3. Verilerin Kullanım Amaçları">
        <p>Kişisel verileriniz yalnızca aşağıdaki amaçlar doğrultusunda işlenir:</p>
        <LegalList items={[
          'Kullanıcı hesabının oluşturulması, yönetilmesi ve doğrulanması',
          'Not yükleme, arama, görüntüleme ve takas hizmetlerinin sunulması',
          'Yüklenen notların yapay zeka destekli kalite ve uygunluk kontrolünden geçirilmesi',
          'Uygunsuz, spam veya alakasız içeriklerin tespit edilerek platformun güvenliğinin sağlanması',
          'Kullanıcı deneyiminin iyileştirilmesi ve teknik hataların giderilmesi',
          'Yetkisiz erişim, sahte hesap ve kötüye kullanım girişimlerinin önlenmesi',
          'Kullanıcı destek taleplerinin yanıtlanması',
          'Yasal yükümlülüklerin ve yetkili kurum taleplerinin karşılanması',
          'İstatistiksel analizlerin yapılması ve hizmetin geliştirilmesi',
        ]} />
      </LegalSection>

      <LegalSection title="4. Verilerin Toplanma Yöntemi">
        <p>Kişisel verileriniz elektronik ortamda aşağıdaki yöntemlerle toplanabilir:</p>
        <LegalList items={[
          'Mobil uygulama veya web sitesi üzerinden hesap oluşturulması',
          'Profil bilgilerinin doldurulması',
          'Ders notu veya belge yüklenmesi',
          'Uygulama içi arama, görüntüleme, indirme veya takas işlemleri yapılması',
          'Destek veya iletişim kanalları aracılığıyla iletişime geçilmesi',
          'Supabase, Firebase ve benzeri teknik altyapılar üzerinden oluşan sistem kayıtları',
          'Gemini API ve benzeri yapay zeka sistemleri üzerinden yapılan içerik analizleri',
        ]} />
      </LegalSection>

      <LegalSection title="5. Çerezler ve İzleme Teknolojileri">
        <p>
          NoteSwapp web sitesi, temel işlevlerin çalışabilmesi ve güvenli oturum yönetimi için zorunlu (teknik) çerezler
          kullanabilir. Üçüncü taraf reklam ve pazarlama amaçlı izleme çerezleri kullanılmamaktadır.
        </p>
        <p>
          Mobil uygulama üzerinden sağlanan hizmetlerde; Firebase ve Supabase gibi altyapı sağlayıcılarının teknik
          işlevler için yerel depolama ve oturum mekanizmalarından yararlanılabilir. Bu mekanizmalar yalnızca hizmetin
          çalışması için gerekli teknik verileri işler.
        </p>
      </LegalSection>

      <LegalSection title="6. Veri Paylaşımı">
        <p>Kişisel verileriniz aşağıdaki taraflarla, yalnızca belirtilen amaçlar dahilinde ve gerekli ölçüde paylaşılabilir:</p>
        <LegalList items={[
          'Supabase — Veri tabanı, kimlik doğrulama ve dosya depolama altyapısı',
          'Firebase — Bildirim, kimlik doğrulama ve teknik altyapı hizmetleri',
          'Gemini API (Google) — Yapay zeka destekli içerik analiz hizmetleri',
          'Bulut ve altyapı sağlayıcıları — Sunucu, hata izleme ve güvenlik hizmetleri',
          'Hukuki danışmanlar — Yasal süreçlerin yürütülmesi',
          'Yetkili kamu kurum ve kuruluşları — Yasal taleplerin karşılanması',
          'Mahkemeler, savcılıklar ve yasal olarak bilgi talep etmeye yetkili makamlar',
        ]} />
        <p>NoteSwapp kişisel verilerinizi üçüncü taraflara satmaz ve reklam amacıyla paylaşmaz.</p>
      </LegalSection>

      <LegalSection title="7. Yurt Dışına Veri Aktarımı">
        <p>
          Supabase, Firebase ve Gemini API gibi hizmet sağlayıcılarının sunucuları yurt dışında konumlanmış olabilir.
          Bu nedenle kişisel verileriniz ve yüklediğiniz not içerikleri; hizmetin sunulması, verilerin saklanması,
          yapay zeka destekli içerik kontrolü ve teknik altyapı yönetimi amaçlarıyla yurt dışına aktarılabilir.
        </p>
        <p>
          Söz konusu aktarımlar, 6698 sayılı KVKK&apos;nın öngördüğü usul ve esaslara uygun biçimde gerçekleştirilir.
          Açık rıza gerektiren aktarımlar için ayrıca <Link to="/acik-riza">Açık Rıza Metni</Link>&apos;nde bilgilendirme
          ve onay mekanizması sunulmaktadır.
        </p>
        <p>
          Platformun temel teknik altyapısının yurt dışı merkezli sunucularda (Supabase, Firebase vb.) bulunması
          sebebiyle, bu aktarıma onay verilmemesi halinde platform hizmetlerinin tam olarak sunulması teknik olarak
          mümkün olamamaktadır.
        </p>
      </LegalSection>

      <LegalSection title="8. Kişisel Verilerin Saklama Süresi">
        <p>
          Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca saklanır. Hesabınız aktif olduğu sürece hesap
          ve profil bilgileriniz muhafaza edilir.
        </p>
        <p>
          Hesap silme talebinde bulunmanız halinde kişisel verileriniz, yasal saklama yükümlülükleri saklı kalmak
          kaydıyla silinir, yok edilir veya anonim hale getirilir. Log kayıtları, güvenlik kayıtları ve uyuşmazlıkla
          ilgili veriler makul sürelerle saklanabilir. Hesap ve veri silme talebi oluşturmak için{' '}
          <Link to="/hesap-silme">Hesap ve Veri Silme Talebi</Link> sayfamızı inceleyebilirsiniz.
        </p>
      </LegalSection>

      <LegalSection title="9. Güvenlik">
        <p>
          NoteSwapp, kişisel verilerinizin hukuka aykırı işlenmesini ve yetkisiz erişimi önlemek için teknik ve idari
          tedbirler uygulamaya çalışır. Bu kapsamda yetkilendirme ve erişim kontrolü, güvenli kimlik doğrulama, veri
          tabanı erişim kısıtlamaları, log kaydı tutma ve içerik güvenlik kontrolleri uygulanmaktadır.
        </p>
        <p>
          İnternet ve elektronik sistemler üzerinden tam güvenlik sağlanamayacağını belirtmek isteriz. Hesap
          bilgilerinizi kimseyle paylaşmamanızı ve güçlü parola kullanmanızı öneririz.
        </p>
      </LegalSection>

      <LegalSection title="10. Haklarınız">
        <p>6698 sayılı KVKK&apos;nın 11. maddesi kapsamında kişisel verilerinize ilişkin aşağıdaki haklara sahipsiniz:</p>
        <LegalList items={[
          'Kişisel verilerinizin işlenip işlenmediğini öğrenme',
          'İşlenmişse buna ilişkin bilgi talep etme',
          'İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme',
          'Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme',
          'Eksik veya yanlış işlenen verilerin düzeltilmesini isteme',
          'Kişisel verilerin silinmesini veya yok edilmesini isteme',
          'Düzeltme, silme veya yok etme işlemlerinin aktarılan üçüncü kişilere bildirilmesini isteme',
          'Otomatik sistemler sonucunda aleyhinize çıkan kararlara itiraz etme',
          'Kanuna aykırı işleme nedeniyle uğradığınız zararın giderilmesini talep etme',
        ]} />
        <p>
          Bu haklarınızı kullanmak için <a href="mailto:noteswapp@gmail.com">noteswapp@gmail.com</a> adresine e-posta
          gönderebilirsiniz. Başvurunuzda ad, soyad, hesap e-postanız ve talebinizin konusu yer almalıdır.
        </p>
      </LegalSection>

      <LegalSection title="11. İletişim">
        <p>
          Bu Gizlilik Politikası&apos;na ilişkin sorularınız, talepleriniz veya şikayetleriniz için{' '}
          <a href="mailto:noteswapp@gmail.com">noteswapp@gmail.com</a> adresinden bizimle iletişime geçebilirsiniz.
        </p>
      </LegalSection>

      <LegalSection title="12. Politika Değişiklikleri">
        <p>
          NoteSwapp, bu Gizlilik Politikası&apos;nı uygulamanın geliştirilmesi, kullanılan hizmet sağlayıcıların
          değişmesi veya mevzuat değişiklikleri nedeniyle güncelleyebilir. Güncel metin her zaman bu web sayfasında
          ve uygulama içinde yayınlanır. Önemli değişiklikler söz konusu olduğunda kullanıcılar e-posta veya uygulama
          içi bildirim yoluyla bilgilendirilebilir.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
